/**
 *
 *
 * OFF NAVIGATION MENU
 *
 *
 */

const nav = document.getElementById('menu');
const btn = document.getElementById('menuBtn');
const body = document.body;

btn.addEventListener('click', function () {
  navToggle();
});

function navToggle() {
  body.classList.toggle('has-menu');
  btn.classList.toggle('open');
  nav.classList.toggle('open');
}
